import { useState, useCallback, createContext, useContext } from 'react';

/**
 * Улучшенный хук useState для работы с объектом состояния
 * @param {Object} initialState - Начальное состояние
 * @returns {Array} [state, setValue, setValues, reset]
 */

const useObjectState = (initialState = {}) => {
    const [state, setState] = useState(initialState);

    // Установка одного значения (значение или функция)
    const setValue = useCallback((key, value) => {
        setState((prev) => {
            const newValue = typeof value === 'function' ? value(prev[key]) : value;
            return {
                ...prev,
                [key]: newValue,
            };
        });
    }, []);

    // Установка нескольких значений (объект или функция)
    const setValues = useCallback((updates) => {
        setState((prev) => {
            const updatesObject = typeof updates === 'function' ? updates(prev) : updates;
            return {
                ...prev,
                ...updatesObject,
            };
        });
    }, []);

    // Сброс состояния к начальному
    const reset = useCallback(() => {
        setState(initialState);
    }, [initialState]);

    return { state, setValue, setValues, reset };
};


const ObjectStateContext = createContext({});

export const useObjectStateContext = () => {

    const context = useContext(ObjectStateContext);

    if (!context) throw new Error('useObjectStateContext должен быть использован вместе с ObjectStateProvider');

    return context;
};

export const ObjectStateProvider = ({ children, initialState, value = {} }) => {

    const objectState = useObjectState(initialState);

    return (
        <ObjectStateContext.Provider value={{ ...objectState, ...value }}>
            {children}
        </ObjectStateContext.Provider>
    );
};

export default useObjectState;